import { useThemeUI } from 'theme-ui';
import { getColor } from '@theme-ui/color';

export const useThemedChart = () => {
  const { theme } = useThemeUI();
  const hinted = getColor(theme, 'hinted');
  const text = getColor(theme, 'text');
  return {
    leftPriceScale: {
      visible: true,
    },
    grid: {
      vertLines: { visible: false },
      horzLines: { visible: false },
    },
    layout: {
      background: { color: hinted },
      textColor: text,
    },
  };
};
